/** @type {import('tailwindcss').Config} */
export default {
  content: ['./index.html', './src/**/*.{js,ts,jsx,tsx}'],
  // NOTE: 動的に設定するものは事前に読み込んでおく
  safelist: ['text-6xl', 'text-5xl', 'text-4xl', 'text-3xl', 'text-2xl', 'text-xl', 'text-lg', 'text-base', 'text-sm', 'text-xs', 'h-16', 'h-20'],
  theme: {
    screens: {
      sp: '0px',
      sp_md: '500px',
      tb: '764px',
      pc: '1024px',
      pc_lg: '1350px',
    },
    extend: {
      fontFamily: {
          verdana: ['Verdana'],
        },
      fontSize: {
        xxxs: ['0.325em', { lineHeight: '0.5rem' }],
        xxs: ['0.625em', { lineHeight: '1rem' }],
      },
      colors: {
        main_text: '#FF5432',
        sub_text: '#0070BB',
        currentChar: '#FF5432',
        remainingChar: '#0170BB',
        completeChar: '#81CCFF',
        copyright: '#7B7B7B',
        translation: '#77787B',
        little_finger: '#FEF4AD',
        ring_finger: '#87C9A5',
        middle_finger: '#B9E3F9',
        index_finger: '#FACD89',
        thumbs_finger: '#D2CCE6',
        main_key: '#000',
        current_key: '#FF5D48',
        error_key: '#FF5D48',
        blank_key: '#EEEEED',
        using_shift_key: '#FFA3A3',
        enable: '#FF7419',
        disable: '#8F8F8F',
        rule_border_t: '#D9A60D',
        rule_border_b: '#FCF4BD',
        event_link: '#09419e',
        // typing-contest2026
        modal_overlay: 'rgba(0, 19, 85, 0.4)',
        tc2026_heading: '#174ca3',
        tc2026_primary: '#09419e',
        tc2026_bg: '#cfeaff',
        tc2026_confirm_bg: '#d1ebff',
        tc2026_section_bg: '#f2f3f6',
        tc2026_badge_text: '#0076d7',
        tc2026_link: '#0900ff',
        event_team_outline: '#ffdd00',
        tc2026_btn_from: '#5555ff',
        tc2026_btn_to: '#3333dd',
        tc2026_btn_disabled: '#9c9c9c',
        tc2026_btn_disabled_border: '#767676',
      },
      backgroundImage: {
        clearMeter: 'linear-gradient(180deg, #F18005 0%, #FE5B48 100%)',
      },
      animation: {
        'fade-in-short': 'fade-in 0.5s ease-in-out',
        'fade-in': 'fade-in 1s ease-in-out',
        'fade-in-long': 'fade-in 1.5s ease-in-out',
        'fade-in-out': 'fade-in-fade-out 5s ease-in-out',
        flash: 'fade-in-fade-out 0.9s ease-in-out',
        'background-effect': 'fade-out-fade-in 5s infinite ease-in-out',
        'shrink-fade': 'shrink-fade 1.1s ease-in-out',
        popup: 'popup 0.3s cubic-bezier(0.22, 1, 0.36, 1) forwards',
        'score-meter': 'score-meter 1s ease-in-out forwards',
        'clear-on-meter': 'fade-in 2s ease-in-out',
        'emphasis-infinite': 'emphasis 1s linear infinite both',
      },
      keyframes: {
        'fade-in': {
          '0%': {
            opacity: '0',
          },
          '100%': {
            opacity: '1',
          },
        },
        'fade-out-fade-in': {
          '0%': {
            opacity: '1',
          },
          '50%': {
            opacity: '0',
          },
          '100%': {
            opacity: '1',
          },
        },
        'fade-in-fade-out': {
          '0%': {
            opacity: '0',
          },
          '50%': {
            opacity: '1',
          },
          '100%': {
            opacity: '0',
          },
        },
        'shrink-fade': {
          '0%': { opacity: 1, transform: 'scale(1)' },
          '100%': { opacity: 0, transform: 'scale(0.7)' },
        },
        popup: {
          '0%': {
            transform: 'translateY(40px) scale(0.8)',
            opacity: 0,
          },
          '100%': {
            transform: 'translateY(0) scale(1.0)',
          },
          '80%, 100%': {
            opacity: 1,
          },
        },
        'score-meter': {
          '0%': { width: '0%' },
          '100%': { width: 'var(width)' },
        },
        emphasis: {
          '0%,50%,to': {
            transform: 'scale(1)',
          },
          '25%,75%': {
            transform: 'scale(1.1)',
          },
        },
      },
      zIndex: {
        '90': '90',
        '100': '100',
      }
    },
  },
  plugins: [],
};
